import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-bookeeper-modal',
  templateUrl: './bookeeper-modal.component.html',
  styleUrls: ['./bookeeper-modal.component.sass'],
})
export class BookeeperModalComponent {
  currentRoute: string | undefined;
  constructor(
    private dialogRef: MatDialogRef<BookeeperModalComponent>
  ) {
    dialogRef.disableClose = true;
  }

  closeDialog(message: string){
    this.dialogRef.close(message);
  }
}
